export const SUCCESS = 'SUCCESS';
export const ERROR = 'ERROR';
export const RESET = 'RESET';

export const successType = (type) => `${type}_${SUCCESS}`;
export const errorType = (type) => `${type}_${ERROR}`;
export const resetType = (type) => `${type}_${RESET}`;

export const getTypes = (type) => ({
    pending: type,
    success: successType(type),
    error: errorType(type),
    reset: resetType(type),
});
